import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {StyledFieldSelect} from '../../../_common/components/FieldSelect';
import {useOrderDetailsUIFilesContext} from '../OrderDetailsUIFilesContext';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ButtonAction from '../../../_common/components/ButtonAction';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import ModalHeader from '../../../_common/components/ModalHeader';

const FormChangeFileType = ({fileID, onClose, fileTypeID = null}) => {
  const {fileTypesOptions, handleUpdateFileType} = useOrderDetailsUIFilesContext();
  const [selected, setSelected] = useState(fileTypeID && fileTypesOptions.filter(option => option.value === fileTypeID)[0]);

  const cancel = () => {
    if (onClose) {
      setSelected(null);
      onClose();
    }
  };

  const confirm = async () => {
    if (selected?.value) {
      await handleUpdateFileType(fileID, selected.value);
      setSelected(null);
      onClose();
    }
  };

  return (
    <>
      <ModalHeader
        header={<FormattedMessage id={'tab-order-documents-popup-edit-file-type-header'} defaultMessage={'Edit file type'}/>}
      />
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldSelect
          value={selected}
          onChange={setSelected}
          options={fileTypesOptions}
        />
      </ModalContent>
      <ModalButtonsContainer customClassnames={largeButtonsPadding}>
        <ButtonAction
          variant={'cancel'}
          onClick={cancel}
          label={'סגירה'}
          customClassnames={buttonCancel}
        />
        <ButtonAction
          onClick={confirm}
          useIcon={'/media/common/Check-in-circle_white.svg'}
          label={'שליחה'}
          customClassnames={buttonSubmit}
        />
      </ModalButtonsContainer>
    </>
  );
};

export default FormChangeFileType;